package team.platforma.multiplatform_material_extension.ui.dialog.style

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.ui.chip.style.InputChipBorder

object CommonDialogStyle {
    private var mDialogStyle: DialogStyle = DialogStyle()

    @Composable
    fun define(
        dialogStyle: DialogStyle = DialogStyle()
    ) {
        mDialogStyle = dialogStyle
    }

    @Composable
    internal fun dialogStyle(): GlobalDialogStyle{
        return GlobalDialogStyle(
            shape = mDialogStyle.shape,
            background = mDialogStyle.background ?: MaterialTheme.colorScheme.background,
            titleColor = mDialogStyle.titleColor ?: MaterialTheme.colorScheme.onBackground,
            borderWidth = mDialogStyle.borderWidth,
            borderColor = mDialogStyle.borderColor
        )
    }
}

data class DialogStyle(
    var shape: Shape = RoundedCornerShape(8.dp),
    var background: Color? = null,
    var titleColor : Color? = null,
    var borderColor: Color = Color.Transparent,
    var borderWidth: Dp = 2.dp
)

internal data class GlobalDialogStyle(
    val shape: Shape,
    val background: Color,
    val titleColor: Color,
    var borderColor: Color,
    var borderWidth: Dp
)